export const CONTACT = 'contact';
export const REPS = 'reps';
export const INFO = 'info';
export const ORG_MODULES = {
  CONTACT,
  REPS,
  INFO,
};

export const INIT_ACCESS = {
  canView: false,
  canUpdate: false,
  canAdmin: false,
};

export const INIT_ORG_ACCESS = {};

export const INIT_PERSON_ACCESS = {};

export const INIT_INDIVIDUAL_CREATION = {};

export const INIT_PAGE_ACCESS = {
  org: INIT_ORG_ACCESS,
  person: INIT_PERSON_ACCESS,
};

export const MODULE_TYPES = {
  organization: 'org',
  person: 'person',
};
